export default {
	"index_nihao":" Hello,{0}",
	"index_jipiao":" Tickets",
	"index_jiudianzhusu":" Hotels",
	"index_huoche":" Trains",
	"index_lvyoudujia":" Tours",
	"index_zhi":" To",
	"index_jian":" Rooms",
	"index_qushenpi":" approve",
	"index_xiangqing":" detail",
	"index_jiantizhongwen":" simplified Chinese",
	"index_jijiangchengxian":" Coming soon",
	"index_ditugongnengkaifazhong":" map functions in development",
	"index_jiudian":" Hotels",
	"index_huochepiao":" Trains",
	"index_yuyan":" language",

	"login_qingtianxiemima":"Please enter your password!",
	"login_wangjimima":"Forgot Password",
	"login_qingshuruyanzhengma":"Please enter the verification code",
	"login_fasongyanzhengma":"Resend verification code",
	"login_denglu":"Sign In",
	"login_yanzhengmadenglu":"Sign In by verification code",
	"login_zhanghaomimadenglu":"Sign In with account names and passwords",
	"login_denglujidaibiaonintongyiwomende":"By proceeding, I acknowledge that I have read and agree to our",
	"login_tongyi": "Agree",
	"login_butongyituichuapp": "Disagree and exit the APP",
	"login_fuwuxieyi":"Terms of Use",
	"login_fuwuxieyitext": "Terms of Use",
	"login_he":"and",
	"login_byyzzbbhsyyhdgrysq": "This application respects and protects the personal privacy rights of all users.",
	"login_wlgntggzq": "To provide you with more accurate",
	"login_gygxhdfw": "More personalized services",
	"login_keyuedu": "Readable",
	"login_byyhazyszcdgdsyhplndgrxx": "This application will use and disclose your personal information in accordance with the privacy policy.",
	"login_yinsizhengce":"Privacy Statement",
	"login_yinsizhengcetext": "Privacy Statement",
	"mall_flight_backtorule_fanhui":"return",
	"mall_flight_backtorule_tuigaiguize":"Policies",
	"mall_flight_backtorule_goupiaoxuzhi":"Ticket Notice",
	"mall_flight_backtorule_nulihuoquzhong":"Processing",
	"mall_flight_flight_chufadi":"departure",
	"mall_flight_flight_mudedi":"arrival",
	"mall_flight_flight_chufashijian":"depart time",
	"mall_flight_flight_fanchengshijian":"return time",
	"mall_flight_flight_cangwei":"class",
	"mall_flight_flight_tianjialvke":"Add passenger",
	"mall_flight_flight_dianjixuanzelvke":"Click to select the passenger",
	"mall_flight_flight_dianjixuanzecangwei": "Click to select the shipping space",
	"mall_flight_flight_sousuo":"search",
	"mall_flight_flight_ruxuyudingertongyingerpiaoqinglianxibengongsikefu":"If you want to book infant ticket ro child ticket, please contact our customer service",
	"mall_flight_flight_toudengcang":"first",
	"mall_flight_flight_shangwucang":"business",
	"mall_flight_flight_jingjicang":"economy",
	"mall_flight_flight_dancheng":"one-way",
	"mall_flight_flight_wangfan":"round-trip",
	"mall_flight_flight_shanghai":"shanghai",
	"mall_flight_flight_beijing":"beijing",
	"mall_flight_flight_guangzhou":"guangzhou",
	"mall_flight_flight_yueri":"MM-DD",
	"mall_flight_flight_qingxuanzelvke":"please select the passenger",
	"mall_flight_flight_shenpidanhangcheng": "To arrive at the destination city, there must be an approved itinerary for the flight!",
    "mall_flight_flight_shenpidanchufariqi": "The departure date must fall within the date range specified in the approval form!",
    "mall_flight_flight_shenpidanchufadaoda": "The return date must fall within the approved date range!",
    "mall_flight_flight_shenpidanmudichengshi": "The destination city must have the approval form for the entire journey!",
	"mall_flight_flightchangeinfos_gaiqian":"change",
	"mall_flight_flightchangeinfos_yuanhangbanxinxi":"Original flight information",
	"mall_flight_flightchangeinfos_di":"The",
	"mall_flight_flightchangeinfos_cheng":"Trip",
	"mall_flight_flightchangeinfos_yueri":"MM-DD",
	"mall_flight_flightchangeinfos_tuigaiguize":"Policies",
	"mall_flight_flightchangeinfos_xinhangbanxinxi":"new flight information",
	"mall_flight_flightchangeinfos_chuhangrenxinxi":"passenger info",
	"mall_flight_flightchangeinfos_shouji":"mobile",
	"mall_flight_flightchangeinfos_shenfenzheng":"ID number",
	"mall_flight_flightchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
	"mall_flight_flightchangeinfos_zongji":"Total",
	"mall_flight_flightchangeinfos_mingxi":"Details",
	"mall_flight_flightchangeinfos_tijiaoshenhe":"submit trip approval",
	"mall_flight_flightchangeinfos_woyaogaibianhangchengbuxiangfeiliao":"I want to change the schedule",
	"mall_flight_flightchangeinfos_jicuohangchengriqishijianxingming":"Forgot the itinerary, date, time or name",
	"mall_flight_flightchangeinfos_hangbanyanwuhuoquxiao":"flight delay or cancellation",
	"mall_flight_flightchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"according to your company's trip rule, please select the reason of change",
	"mall_flight_flightchangeinfos_gongxinintijiaochenggongqingnaixindengdaikefuhejia":"Submitted successfully. Please be patient and wait customer service account the price",
	"mall_flight_flightchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie":"The order can't be changed now. Please contact the customer service, thank you.",
	"mall_flight_flightdetails_hangbanxiangqing":"Flight Details",
	"mall_flight_flightdetails_zhifei":"nonstop",
	"mall_flight_flightdetails_yueri":"MM-DD",
	"mall_flight_flightdetails_yixiafeiyongjunweichengrenhuoertonghuoyingerderenjunjia":"The following charge is the average price of an adult or a child or an infant.",
	"mall_flight_flightdetails_shangwutuijian":"business Recommendation",
	"mall_flight_flightdetails_baoxian":"insurance",
	"mall_flight_flightdetails_jinsheng":"Only",
	"mall_flight_flightdetails_zhang":"tickets",
	"mall_flight_flightdetails_tuigaiguize":"Policies",
	"mall_flight_flightdetails_weibeizhengce":"Violating policy",
	"mall_flight_flightdetails_fuhezhengce":"conforming policy ",
	"mall_flight_flightdetails_ding":"book",
	"mall_flight_flightdetails_tuipiaozhongkai":"Refund and book new one",
	"mall_flight_flightdetails_tuigaishiduan":"prior to departure ",
	"mall_flight_flightdetails_tuipiaofeiyong":"REFUND FEE",
	"mall_flight_flightdetails_gaiqianfeiyong":"CHANGE FEE",
	"mall_flight_flightdetails_qian":"before",
	"mall_flight_flightdetails_ren":"￥{0}/per",
	"mall_flight_flightdetails_hanglie":"Baggage Allowance",
	"mall_flight_flightdetails_yihangkonggongsizuixinguidingweizhunkezixunkefudianhua":"determined by the airline. Please contact the customer service",
	"mall_flight_flightdetails_yscrtgqgzjfybzjgcksj":"Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
	"mall_flight_flightdetails_tuigaiguizeyihangsishenheweizhun":"Cancellation and change policies are based on the airline",
	"mall_flight_flightdetails_weibei":"violate",
	"mall_flight_flightdetails_qingyihangsishenheweizhun":"Please subject to the airline's review",
	"mall_flight_flightdetails_gaihangbanweiyinbeiguizebukeyuding":"you can't book this flight according to the rules",
	"mall_flight_flightdetails_nsyddxyjgxytqbàcngsy":"The ticket you book should be filed on record before use. Please contact with 4000888020, thank you",
	"mall_flight_flightdetails_zhe":"",//英语思维的问题，暂时置空
	"mall_flight_flightlist_zhongzhuan":"transit",
	"mall_flight_flightlist_jinsheng":"Only",
	"mall_flight_flightlist_zhang":"Tickets",
	"mall_flight_flightlist_chongzu":"enough",
	"mall_flight_flightlist_jingting":"stopover",
	"mall_flight_flightlist_weibeiguize":"violate rules",
	"mall_flight_flightlist_fuhezhengce":"conforming policy ",
	"mall_flight_flightlist_jiazaizhong":"Processing",
	"mall_flight_flightlist_shanghai":"shanghai",
	"mall_flight_flightlist_beijing":"beijing",
	"mall_flight_flightorder_zhifei":"non-stop",
	"mall_flight_flightorder_yueri":"MM-DD",
	"mall_flight_flightorder_piaojia":"price",
	"mall_flight_flightorder_yuan":"CNY",
	"mall_flight_flightorder_jijianranyou":"Airport construction fee",
	"mall_flight_flightorder_yuanren":"per",
	"mall_flight_flightorder_baoxian":"insurance",
	"mall_flight_flightorder_hangbanxiangqing":"Flight Details",
	"mall_flight_flightorder_xuanzechuhangren":"select the passenger",
	"mall_hotel_hotel_ruzhushijian":"checkin",
	"mall_hotel_hotel_gong":"total",
	"mall_hotel_hotel_wan":"nights",
	"mall_hotel_hotel_lidianshijian":"check-out",
	"mall_hotel_hotel_guanjianziweizhipinpaijiudianming":"key words/region/Brand/hotel name",
	"mall_hotel_hotel_qingshuruguanjianziweizhipinpaijiudianming":"please fill in key words/region/Brand/hotel name",
	"mall_hotel_hotel_tianjialvke":"Add passenger",
	"mall_hotel_hotel_dianjixuanzelvke":"Click to select the passenger",
	"mall_hotel_hotel_sousuo":"search",
	"mall_hotel_hotel_dfjqbycgjrzrqbycgwrx":"Please do not book over 5 rooms or 20 nights. If you have special needs please contact with customer service.",
	"mall_hotel_hotel_shanghai":"shanghai",
	"mall_hotel_hotel_yueri":"MM-DD",
	"mall_hotel_hotel_qingxuanzelvke":"please select the passenger",
	"mall_hotel_hotel_lvkeshuliangshangxianqinglianxikefu":"The amount of passengers reached limit. Please contact with customer service.",
	"mall_hotel_hotel_wenxintishi":"WARM PROMPT",
	"mall_hotel_hotel_zxydcgwfyknbzjylxkfh":"Book more than 20 nights. There is no adequent rooms provided. Please contact with customer service.",
	"mall_hotel_hotel_jixuyuding":"Continue to book",
	"mall_hotel_hotel_lianxikefu":"contact with customer service",
	"mall_hotel_hoteldetails_fanhui":"return",
	"mall_hotel_hoteldetails_pingfen":"rating",
	"mall_hotel_hoteldetails_fen":"ratings",
	"mall_hotel_hoteldetails_zanwupingfen":"no rating",
	"mall_hotel_hoteldetails_xingji":"star rating",
	"mall_hotel_hoteldetails_tingchechang":"parking lot",
	"mall_hotel_hoteldetails_jianshenfang":"Gym",
	"mall_hotel_hoteldetails_hanglijicun":"Luggage storage",
	"mall_hotel_hoteldetails_dizhi":"address",
	"mall_hotel_hoteldetails_dianhua":"telephone",
	"mall_hotel_hoteldetails_yueri":"MM-DD",
	"mall_hotel_hoteldetails_wan":"night",
	"mall_hotel_hoteldetails_jianren":"room",
	"mall_hotel_hoteldetails_qi":"from￥{0}",
	"mall_hotel_hoteldetails_zao":"breakfast",
	"mall_hotel_hoteldetails_kezhu":"bookable",
	"mall_hotel_hoteldetails_ren":"person",
	"mall_hotel_hoteldetails_bukequxiao":"Non-refundable",
	"mall_hotel_hoteldetails_fuhezhengce":"conforming policy ",
	"mall_hotel_hoteldetails_weibeizhengce":"Violating policy",
	"mall_hotel_hoteldetails_yuding":"book",
	"mall_hotel_hoteldetails_gaijiudianzanwuheshifangjian":"The hotel cannot provide suitable rooms.",
	"mall_hotel_hoteldetails_xieyijiudian":"Contract hotels",
	"mall_hotel_hoteldetails_wu":"NONE",
	"mall_hotel_hoteldetails_dan":"one",
	"mall_hotel_hoteldetails_shuang":"double",
	"mall_hotel_hoteldetails_duo":"Multiple",
	"mall_hotel_hoteldetails_weibei":"violate",
	"mall_hotel_hoteldetails_gaifangjianyinweibeiguizebukeyuding":"The room cannot be booked because of violating policy",
	"mall_hotel_hoteldetails_wenxintishi":"WARM PROMPT",
	"mall_hotel_hoteldetails_bjdwxyjdknczfxqnzxbh":"This hotel is contract hotel. Please kindly note the potential risks and properly plan the trips, thank you.",
	"mall_hotel_hotellist_meiyougengduoliao":"No more",
	"mall_hotel_hotellist_qi":"from￥{0}",
	"mall_hotel_hotellist_fen":"rating",
	"mall_hotel_hotellist_weibeiguize":"violate rules",
	"mall_hotel_hotellist_fuhezhengce":"conforming policy ",
	"mall_hotel_hotellist_jiazaizhong":"Processing",
	"mall_hotel_hotellist_xieyijiudian":"Contract hotels",
	"mall_hotel_hotelorder_ruzhu":"check in",
	"mall_hotel_hotelorder_wan":"nigth",
	"mall_hotel_hotelorder_lidian":"check out",
	"mall_hotel_hotelorder_jian":"room",
	"mall_hotel_hotelorder_dingdanquerenhoubukequxiao":"The order cannot be cancelled after confirmation",
	"mall_hotel_hotelorder_tuigaixiangqing":"need to know",
	"mall_hotel_hotelorder_ruzhuxinxi":"check-in information",
	"mall_hotel_hotelorder_dingdantianxie":"fill order",
	"mall_hotel_hotelorder_yueri":"MM-DD",
	"mall_modules_addpassengers_fanhui":"return",
	"mall_modules_addpassengers_tianjiachengke":"Add passenger",
	"mall_modules_addpassengers_wancheng":"complete",
	"mall_modules_addpassengers_qingshurulvkemingchengpipeihuotianjiaweilinke":"Please match the passenger name or add a temporary guest",
	"mall_modules_addpassengers_tianjia":"add",
	"mall_modules_addpassengers_wei":"to",
	"mall_modules_addpassengers_linke":"temporary guest",
	"mall_modules_addpassengers_shanchu":"delete",
	"mall_modules_addpassengers_qingjianglinkemingchengshurudaosousuokuangneihouzhongshi":"Please enter the temporary guest name into the search box and try again.",
	"mall_modules_change_gaiqian":"change",
	"mall_modules_change_gaiqianyuanyin":"reason to change",
	"mall_modules_change_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
	"mall_modules_change_xiayibuqingxuanzegaiqianriqi":"Next Step: please select the date you want to change",
	"mall_modules_change_tuigaiguize":"Policies",
	"mall_modules_change_woyaogaibianhangchengbuxiangfeiliao":"I want to change the schedule.",
	"mall_modules_change_jicuohangchengriqishijianxingming":"Forgot the itinerary, date, time or name",
	"mall_modules_change_hangbanyanwuhuoquxiao":"flight delay or cancellation",
	"mall_modules_change_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"according to your company's trip rule, please select the reason of change",
	"mall_modules_change_qingxuanzexuyaogaiqiandelvcheng":"Please select the itinerary you want to change",
	"mall_modules_change_qingxuanzelvke":"please select the passenger",
	"mall_modules_change_shanghai":"shanghai",
	"mall_modules_change_beijing":"beijing",
	"mall_modules_change_gaichecimeiyoupipeituigaiguize":"This train cannot match the policy.",
	"mall_modules_choosecontraryreason_weibeiyuanyin":"reason of violations",
	"mall_modules_choosecontraryreason_qingshuruliyoumingcheng":"Please explain the reason",
	"mall_modules_choosecostcenter_chengbenzhongxin":"cost center",
	"mall_modules_chooseprojectcode_qingshuruxiangmudaima":"Please write the project code",
	"mall_modules_chooseprojectcode_tianjia":"add",
	"mall_modules_chooseprojectcode_weixiangmudaima":"project code",
	"mall_modules_choosetripintent_chalvmude":"travel purpose",
	"mall_modules_choosetripintent_qingshuruchalvmude":"Please fill in the purpose of travel",
	"mall_modules_editrole_fanhui":"return",
	"mall_modules_editrole_tianjialinke":"add temporary guest",
	"mall_modules_editrole_xingpinyin":"Last name",
	"mall_modules_editrole_mingpinyin":"First & middle name",
	"mall_modules_editrole_zhongwenxingming":"chinese name",
	"mall_modules_editrole_qingshuruxingming":"Please enter your name ",
	"mall_modules_editrole_zhengjianleixing":"ID Type",
	"mall_modules_editrole_dianjixuanzezhengjianleixing":"Please select the ID Type",
	"mall_modules_editrole_xingbie":"Gender",
	"mall_modules_editrole_dianjixuanzexingbie":"please select the gender",
	"mall_modules_editrole_guoji":"Nationality",
	"mall_modules_editrole_dianjixuanzeguoji":"please select the nationality",
	"mall_modules_editrole_zhengjianhaoma":"ID number",
	"mall_modules_editrole_qingshuruzhengjianhaoma":"please enter the ID number",
	"mall_modules_editrole_chushengriqi":"Date of birth",
	"mall_modules_editrole_dianjixuanzechushengriqi":"please select the date of birth",
	"mall_modules_editrole_shoujihaoma":"telephone no.",
	"mall_modules_editrole_qingshurushoujihaoma":"please enter the telephone no.",
	"mall_modules_editrole_youxiang": "Email",
	"mall_modules_editrole_qingtianxieyouxianghaoma": "Please fill in the email number",
	"mall_modules_editrole_sfbcwck": "Are regular visitors preserved",
	"mall_modules_editrole_baocun":"save",
	"mall_modules_editrole_lichenggongsi":"Licheng Business Trip",
	"mall_modules_editrole_nan":"male",
	"mall_modules_editrole_nv":"female",
	"mall_modules_editrole_zhongguo":"china",
	"mall_modules_frequentercardfill_fanhui":"return",
	"mall_modules_frequentercardfill_tianxiechangkelvkeqia":"fill in frequent flyer card No.",
	"mall_modules_frequentercardfill_zhangsan":"Chinese, pinyin or English",
	"mall_modules_frequentercardfill_qingxuanzehangkonggongsi":"Please select the airline",
	"mall_modules_frequentercardfill_qingtianxiechanglvkeqiahao":"Please fill in frequent flyer card No.",
	"mall_modules_frequentercardfill_wancheng":"complete",
	"mall_modules_frequentercardfill_dongfanghangkong":"China Eastern Airlines",
	"mall_modules_frequentercardfill_zhongguohangkong":"Air China",
	"mall_modules_frequentercardfill_nanfanghangkong":"China Southern Airlines",
	"mall_modules_productdetails_fanhui":"return",
	"mall_modules_producthome_chalvguizemingcheng":"Travel rules",
	"mall_modules_producthome_zuidijiagejizhun":"lowest price standard",
	"mall_modules_producthome_shishihangbanguankong":"management of real time flight",
	"mall_modules_producthome_tiqianyudingshijian":"advanced booking time",
	"mall_modules_producthome_cangweijibiexianzhi":"Class limitation",
	"mall_modules_producthome_zuoweijibiexianzhi":"Class limitation",
	"mall_modules_producthome_xieyijipiaoyouxian":"contract tickets first",
	"mall_modules_producthome_xieyijiudianyouxian":"Contract hotels first",
	"mall_modules_producthome_xiaofeijineshangxian":"upper limitation of consumption",
	"mall_modules_producthome_shenpimingcheng":"Approval name",
	"mall_modules_producthome_toudengcang":"first class",
	"mall_modules_producthome_shangwucang":"business class",
	"mall_modules_producthome_jingjicang":"economy class",
	"mall_modules_producthome_jingjicangzhe":"economy class (50% off)",
	"mall_modules_producthome_yinei":"Within",
	"mall_modules_producthome_bufenhangxian":"some routes",
	"mall_modules_producthome_bufenjiudian":"some hotels",
	"mall_modules_producthome_jichengshiyinei":"within  -class city",
	"mall_modules_productlist_fanhui":"return",
	"mall_modules_productlist_tuigaiguize":"Policies",
	// "mall_modules_productlist_zhu":"check in",
	"mall_modules_productlist_zhu":"ARR", // Arrival Date: ARR 抵店日     
	// "mall_modules_productlist_li":"check out",
	"mall_modules_productlist_li":"DEP", // Departure Date：DEP 离店日
	"mall_modules_productlist_guanjianziweizhijiudianmingpinpai":"key words/region/hotel name/Brand",
	// "mall_modules_productlist_qianyitian":"the previous day",
	"mall_modules_productlist_qianyitian":"before",
	// "mall_modules_productlist_houyitian":"the following day",
	"mall_modules_productlist_houyitian":"after",
	"mall_modules_productlist_weizhijuli":"Location distance",
	"mall_modules_productlist_jiagexingji":"price/star rating",
	"mall_modules_productlist_shaixuan":"Filter",
	"mall_modules_productlist_queren":"confirm",
	"mall_modules_productlist_gengduoshaixuan":"more Filter",
	"mall_modules_productlist_chalvguizemingcheng":"Travel rules",
	"mall_modules_productlist_zuidijiagejizhun":"lowest price standard",
	"mall_modules_productlist_shishihangbanguankong":"management of real time flight",
	"mall_modules_productlist_tiqianyudingshijian":"advanced booking time",
	"mall_modules_productlist_cangweijibiexianzhi":"Class limitation",
	"mall_modules_productlist_zuoweijibiexianzhi":"Class limitation",
	"mall_modules_productlist_xieyijipiaoyouxian":"contract tickets first",
	"mall_modules_productlist_xieyijiudianyouxian":"Contract hotels first",
	"mall_modules_productlist_xiaofeijineshangxian":"upper limitation of consumption",
	"mall_modules_productlist_shenpimingcheng":"Approval name",
	"mall_modules_productlist_toudengcang":"first class",
	"mall_modules_productlist_shangwucang":"business class",
	"mall_modules_productlist_jingjicang":"economy class",
	"mall_modules_productlist_jingjicangzhe":"economy class (50% off)",
	"mall_modules_productlist_hangzhengqu":"administrative area",
	"mall_modules_productlist_buxian":"Unlimited",
	"mall_modules_productlist_shangyequ":"commercial areas",
	"mall_modules_productlist_jiage":"price",
	"mall_modules_productlist_yixia":"less than 150",
	"mall_modules_productlist_yishang":"more than 600",
	"mall_modules_productlist_xingji":"star rating",
	"mall_modules_productlist_erxingjijiyixia":"two stars and below",
	"mall_modules_productlist_sanxingjishushi":"Three stars / comfortable",
	"mall_modules_productlist_sixingjigaodang":"Four stars / upscale",
	"mall_modules_productlist_wuxingjihaohua":"Five stars / luxurious",
	"mall_modules_productlist_tese":"Features",
	"mall_modules_productlist_fuwu":"service",
	"mall_modules_productlist_chexingxuanze":"train type",
	"mall_modules_productlist_gaotie":"High-speed train(G/C)",
	"mall_modules_productlist_dongche":"High-speed train(D)",
	"mall_modules_productlist_putong":"common(Z/T/K)",
	"mall_modules_productlist_qitadeng":"other(L/Y etc.)",
	"mall_modules_productlist_qita":"other",
	"mall_modules_productlist_facheshijian":"Departure Time",
	"mall_modules_productlist_chalvzhengce":"Travel rules",
	"mall_modules_productlist_fuhezhengce":"conforming policy ",
	"mall_modules_productlist_weibeiguize":"violate rules",
	"mall_modules_productlist_chufachezhan":"Departure Station",
	"mall_modules_productlist_daodachezhan":"Arrival Station",
	"mall_modules_productlist_zhinengpaixu":"intelligent sorting",
	"mall_modules_productlist_morenpaixu":"Default sort",
	"mall_modules_productlist_dijiayouxian":"lowest",
	"mall_modules_productlist_gaojiayouxian":"highest",
	"mall_modules_productlist_xingjiyouxian":"star rating first",
	"mall_modules_productlist_putongyouxian":"common first",
	"mall_modules_productlist_shijianpaixu":"time sorting",
	"mall_modules_productlist_congzaodaowan":"earliest to latest",
	"mall_modules_productlist_congwandaozao":"latest to earliest",
	"mall_modules_productlist_jiagepaixu":"price ranking",
	"mall_modules_productlist_congdidaogao":"low to high",
	"mall_modules_productlist_conggaodaodi":"high to low",
	"mall_modules_productlist_qifeishijian":"Departure Time",
	"mall_modules_productlist_qifeijichang":"Departure Airport",
	"mall_modules_productlist_daodajichang":"Arrival Airport",
	"mall_modules_productlist_cangwei":"class",
	"mall_modules_productlist_hangkonggongsi":"Airline",
	"mall_modules_productlist_yinei":"Within",
	"mall_modules_productlist_bufenhangxian":"some routes",
	"mall_modules_productlist_bufenjiudian":"some hotels",
	"mall_modules_productlist_jichengshiyinei":"within  -class city",
	"mall_modules_addkeywords_guanjianziweizhijiudianmingpinpai":"key words/region/hotel name/Brand",
	"mall_modules_addkeywords_qsrhxggjzwzppjdmckssjg":"Please enter or modify keywords / location / brand / hotel name to view the search results",
	"mall_modules_refund_tuidingyuanyin":"Reason for Cancellation",
	"mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
	"mall_modules_refund_zongji":"Total",
	"mall_modules_refund_yujituipiaofei": "Refund Fee：",
	"mall_modules_refund_mingxi":"Details",
	"mall_modules_refund_tijiaoshenhe":"submit trip approval",
	"mall_modules_refund_hangchengbiangeng":"travel change",
	"mall_modules_refund_hangchengquxiao":"travel cancellation",
	"mall_modules_refund_woyaogaibianhangchengbuxiangfeiliao":"I want to change the schedule",
	"mall_modules_refund_jicuohangchengriqishijianxingming":"Forgot the itinerary, date, time or name",
	"mall_modules_refund_hangbanyanwuhuoquxiao":"flight delay or cancellation",
	"mall_modules_refund_genjuguisidechalvbiaozhunqingxuanzetuidingyuanyin":"according to your company's trip rule, please select the reason of refund",
	"mall_modules_refund_shenqingtuipiao":"apply a refund",
	"mall_modules_refund_shenqingtuifang":"apply a refund",
	"mall_modules_refund_qingxuanzexuyaotuidingdelvcheng":"Please select the itinerary you want to refund",
	"mall_modules_refund_qingxuanzelvke":"please select the passenger",
	"mall_modules_refund_qingxuanzetuidingyuanyin":"please select the reason of refund",
	"mall_modules_refund_tuipiaoshenqingtijiaochenggong":"The refund application is submitted successfully",
	"mall_modules_remarks_xuqiubeizhu":"requirements note",
	"mall_modules_remarks_baocun":"save",
	"mall_modules_remarks_ndtsxqwmhjlxtrwfmzwm":"We will try our best to coordinate with your special needs. If it cannot be satisfied, we will not notify you, please understand",
	"mall_order_shifa":"Departure ",
	"mall_order_yueri":"MM-DD",
	"mall_order_tuigaixuzhi": "Change prompt",
	"mall_order_fangjianshu":"Number of Rooms",
	"mall_order_jian":"room",
	"mall_order_rfjcgwjsklxkfhcfyd": "If there are more than 5 rooms, please contact customer service or split the booking!",
	"mall_order_meijianzuiduokezhu":"Each room can live at most",
	"mall_order_ren":"person",
	"mall_order_zuoxixuanze":"Seat Selection",
	"mall_order_chuang": "Window",
	"mall_order_guodao": "Aisle",
	"mall_order_wbzndslcxqwbbztxxycysczjyz": "In order to make sure that the entry is consistent with the certificate you have for your trip",
	"mall_order_fasongduanxin":"send message",
	"mall_order_baoxianxinxi":"Insurance information",
	"mall_order_yqqjjqfhslrsbxdzfwyf":"enhancing protection During COVID-19, customizing insurance services for business travelers. one protection, peace of mind for the whole family",
	"mall_order_shanglvxinxi":"Business Travel Information",
	"mall_order_shenpidanhao":"Approval number",
	"mall_order_liuchenglingdaochuchabaogaodanhao":"IMIS Process leader business trip report number",
	"mall_order_chengbenzhongxin":"cost center",
	"mall_order_qingxuanzechengbenzhongxin":"please select cost center",
	"mall_order_chalvmude":"travel purpose",
	"mall_order_qingxuanzechalvmude":"please select the travel purpose",
	"mall_order_mudexiangqing":"travel purpose",
	"mall_order_chalvmudebumingquexubuchongxiangxichalvmude":"The travel purpose is not clear. Please add the details.",
	"mall_order_xiangmudaima":"the project code",
	"mall_order_qingxuanzexiangmudaima":"please select project code",
	"mall_order_weibeiyuanyin":"reason of violations",
	"mall_order_yusuanbianma": "BudgetCode",
	"mall_order_fujianxinxi": "Attachment Info",
	"mall_order_yusuanmiaoshu": "BudgetIntro",
	"mall_order_xingchengweibeile": "The schedule violates",
	'mall_order_dezhengce': "the policy of",
	"mall_order_qingxuanzeweibeiyuanyin":"please select the reason of violations",
	"mall_order_xiangxiyuanyin":"reason",
	"mall_order_lianxirenxinxi":"Contact Info",
	"mall_order_xingming":"name",
	"mall_order_qingshuruyonghuming":"please enter user name",
	"mall_order_shouji":"telephone",
	"mall_order_qingshurushoujihao":"please enter the telephone no.",
	"mall_order_youxiang":"email address",
	"mall_order_qingshuruyouxiang":"please enter the email address",
	"mall_order_xuqiubeizhu":"requirements note",
	"mall_order_koukuanshuoming":"Deduction instructions",
	"mall_order_hgjndfkfsjhysqhkcffr":"According to the payment method we will pre-authorize your card or deduct room fee. If the order is not confirmed, we will release the pre-authorization or give you a full refund to your account. The order can't be changed or cancelled. You will be billed for the first night's room charge if you don't check in. If you check out in advance you will be billed for the day's room charge.",
	"mall_order_tebietishi":"Special Requests",
	"mall_order_gjddrzsjwtfbzjssjwrt":"The earliest check-in time is 14:00. The check-out time is 12:00. If you arrive before this time or departure after this time, you may need subject to a fee.",
	"mall_order_mingxi":"Details",
	"mall_order_tijiaozhifu":"book",
	"mall_order_feiyongmingxi":"Price Details",
	"mall_order_baoxianfei":"insurance premiums",
	"mall_order_fuwufei":"Service charge",
	"mall_order_zonge":"Total",
	"mall_order_dingdanzhengzaishengcheng":"Order is being generated",
	"mall_order_nulizhanzuozhong":"Processing",
	"mall_order_tuipiaoshuoming":"Refund instructions",
	"mall_order_dgcgwqpqfcqsjdyfzkjr":"purchase successfully. If the ticket is not collected or the time before departure is more than 35 minutes, you can enter “my booking”to apply for refund according to the prompt; refund within 15 days before departure, the Railway Bureau will charge a refund fee for each ticket on a ladder basis.",
	"mall_order_dgcgyqphfcqsjxyfzxnz":"purchase successfully. If tickets have been collected or the time before departure is less than 35 minutes, you should bring the passenger’s original valid certificate and the train ticket to the railway station refund window before departure.",
	"mall_order_gaiqianshuoming":"Change instructions",
	"mall_order_wqzzpqlfcsjdyfzkgqdy":"If the ticket is not collected or the time before departure is more than 35 minutes, the tickets can be changed to the train equal to or less than the original fare.",
	"mall_order_kcqxsyskgqysqndcckcq":"More than 48 hours before the departure time, you can change the train of pre-sale period. Within 48 hours before the departure time, you can change your tickets to any train before 24:00 on the day. The tickets cannot be changed to the train on the day after the date of the original one.",
	"mall_order_xcppjdyycpdthcédcébf":"If the new ticket price is lower than the original ticket, the difference shall be returned. And the refund fee for the difference shall be collected and the current refund fee standards shall be implemented.",
	"mall_order_querendingdan":"Confirm Order",
	"mall_order_xuanzechuhangren":"select the passenger",
	"mall_order_lichenggongsi":"Licheng Business Trip",
	"mall_order_yi":"first",
	"mall_order_er":"second ",
	"mall_order_san":"third",
	"mall_order_yueri1":"MM-DD",
	"mall_order_qingtianxiexiangmudaima":"please fill in the project code",
	"mall_order_qingtianxieshenpidanhao":"please fill in the approval order no",
	"mall_order_qingtianxiechalvmude":"Please fill in the purpose of travel",
	"mall_order_qingtianxiexiangqingmude":"Please fill in the detail of purpose",
	"mall_order_qingtianxieweibeixiangqingyuanyin":"please fill in the reason of violations",
	"mall_order_ghbjpwzhxscpnxxzyzbx":"This flight ticket is a combination sale product, you need to select an insurance product. Or please choose another flight ticket",
	"mall_order_gcczxwzhxscpnxxzyzbx":"This train is a combination sales product, you need to select an insurance product. Or please choose another train",
	"mall_order_qingtianxielvkezhengjianhaoma":"please enter the ID number",
	"mall_order_wenxintishi":"WARM PROMPT",
	"mall_order_shifoujixuyuding":"continue booking or not",
	"mall_order_ddcjcghynsszddxxzgzd":"The order is created successfully, you are welcome to follow the order progress in the order details at any time",
	"mall_order_hejiazhong":"price checking",
	"mall_order_fangjianshubukedayuruzhurenshu":"The number of rooms cannot be greater than the number of occupants",
	"mall_train_train_chufadi":"departure",
	"mall_train_train_mudedi":"arrival",
	"mall_train_train_chufashijian":"departure time",
	"mall_train_train_zuoxi":"seat",
	"mall_train_train_yidengzuo":"first class",
	"mall_train_train_tianjialvke":"Add passenger",
	"mall_train_train_dianjixuanzelvke":"Click to select the passenger",
	"mall_train_train_sousuo":"search",
	"mall_train_train_dangqianshiduanbutigongchecichaxunfuwu":"We don't provide train service in the current time",
	"mall_train_train_tsgpsjwzwgpgqhtpxbwy":"NOTICE: Booking time is from 5:30 am to 00:30 pm. You can book,change and refund tickets more than 30 minutes prior to departure. The tickets within 24 hours should be paid in 10 minutes. The tickets beyond 24 hours should be paid in 25 minutes.",
	"mall_train_train_shanghai":"shanghai",
	"mall_train_train_beijing":"beijing",
	"mall_train_train_yueri":"MM-DD",
	"mall_train_train_qingxuanzelvke":"please select the passenger",
	"mall_train_trainchangeinfos_gaiqian":"change",
	"mall_train_trainchangeinfos_yuanchecixinxi":"original train info",
	"mall_train_trainchangeinfos_di":"No.",
	"mall_train_trainchangeinfos_cheng":"trip",
	"mall_train_trainchangeinfos_yueri":"MM-DD",
	"mall_train_trainchangeinfos_tuigaiguize":"Policies",
	"mall_train_trainchangeinfos_xinchecixinxi":"new train info",
	"mall_train_trainchangeinfos_chuhangrenxinxi":"passenger info",
	"mall_train_trainchangeinfos_shouji":"telephone no.",
	"mall_train_trainchangeinfos_shenfenzheng":"ID number",
	"mall_train_trainchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyishijishenheweizhun":"Refund and change rules and fee standards should be determined by the actual review",
	"mall_train_trainchangeinfos_zongji":"Total",
	"mall_train_trainchangeinfos_mingxi":"Details",
	"mall_train_trainchangeinfos_tijiaoshenhe":"submit trip approval",
	"mall_train_trainchangeinfos_woyaogaibianhangchengbuxiangfeiliao":"I want to change the schedule",
	"mall_train_trainchangeinfos_jicuohangchengriqishijianxingming":"Forgot the itinerary, date, time or name",
	"mall_train_trainchangeinfos_hangbanyanwuhuoquxiao":"flight delay or cancellation",
	"mall_train_trainchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"according to your company's trip rule, please select the reason of change",
	"mall_train_trainchangeinfos_gaiqianchenggongqingninguanzhudingdanzhuangtai":"The change is successful. please pay attention to the status of the order!",
	"mall_train_trainchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie":"The current order cannot be changed, please contact customer service, thank you!",
	"mall_train_traindetails_checixiangqing":"train details",
	"mall_train_traindetails_tuigaiguize":"Policies",
	"mall_train_traindetails_shifa":"Departure ",
	"mall_train_traindetails_weibeizhengce":"Violating policy",
	"mall_train_traindetails_fuhezhengce":"conforming policy ",
	"mall_train_traindetails_youpiao":"Avoir un billet",
	"mall_train_traindetails_wupiao":"sold out",
	"mall_train_traindetails_jinsheng":"Reste",
	"mall_train_traindetails_zhang":"ticket",
	"mall_train_traindetails_ding":"book",
	"mall_train_traindetails_tuipiaoshuoming":"Refund instructions",
	"mall_train_traindetails_dgcgwqpqfcqsjdyfzkjr":"Book successfully. If the ticket is not collected or the time before departure is more than 35 minutes, you can enter “my booking”to apply for refund according to the prompt; refund within 15 days before departure, the Railway Bureau will charge a refund fee for each ticket on a ladder basis.",
	"mall_train_traindetails_dgcgyqphfcqsjxyfzxnz":"Book successfully. If tickets have been collected or the time before departure is less than 35 minutes, you should bring the passenger’s original valid certificate and the train ticket to the railway station refund window before departure.",
	"mall_train_traindetails_gaiqianshuoming":"Change instructions",
	"mall_train_traindetails_wqzzpqlfcsjdyfzkgqdy":"If the ticket is not collected or the time before departure is more than 35 minutes, the tickets can be changed to the train equal to or less than the original fare.",
	"mall_train_traindetails_kcqxsyskgqysqndcckcq":"More than 48 hours before the departure time, you can change the train of pre-sale period. Within 48 hours before the departure time, you can change your tickets to any train before 24:00 on the day. The tickets cannot be changed to the train on the day after the date of the original one.",
	"mall_train_traindetails_xcppjdyycpdthcédcébf":"If the new ticket price is lower than the original ticket, the difference shall be returned. And the refund fee for the difference shall be collected and the current refund fee standards shall be implemented.",
	"mall_train_traindetails_weibei":"violate",
	"mall_train_trainlist_weibeiguize":"violate rules",
	"mall_train_trainlist_fuhezhengce":"conforming policy ",
	"mall_train_trainlist_shouqi":"Show less",
	"mall_train_trainlist_zhankai":"Show More",
	"mall_train_trainlist_you":"exist",
	"mall_train_trainlist_zhang":"ticket",
	"mall_train_trainlist_wu":"not",
	"mall_train_trainlist_zhanxu":"station no.",
	"mall_train_trainlist_zhanming":"station name",
	"mall_train_trainlist_daoshi":"Arrival time",
	"mall_train_trainlist_fashi":"depart time",
	"mall_train_trainlist_tingliu":"stopover",
	"mall_train_trainlist_jiazaizhong":"Processing",
	"mall_train_trainlist_xiuxizhongmingtianzailai":"Rest",
	"mall_train_trainlist_dqcczxwypqnlxqtcchlā":"There are no more seats for the current train! Please choose another train and arrange your trip reasonably, thank you!",
	"mall_train_trainlist_qita":"other",
	"mall_train_trainorder_zhifei":"non-stop",
	"mall_train_trainorder_yueri":"MM-DD",
	"mall_train_trainorder_piaojia":"price",
	"mall_train_trainorder_yuan":"",
	"mall_train_trainorder_jijianranyou":"Airport construction fee",
	"mall_train_trainorder_yuanrenbaoxianyuanren":"insurance 20CNY/per",
	"mall_train_trainorder_checixiangqing":"details",

	"modules_selectcity_qingshuruchengshimingcheng":"Please enter the city name ",
	"modules_selectcity_diqu":"area",
	"modules_selectcity_chezhan":"station",
	"modules_selectcity_remen":"Popular recommend ",
	"modules_webmap_dingwei":" location",
	"modules_webmap_wodebeizhu":"My notes",
	"modules_webmap_wodebiaoji":"My mark",

	"order_flight_flightdetail_di":"",
	"order_flight_flightdetail_cheng":"trip",
	"order_flight_flightdetail_yueri":"MM-DD",
	"order_flight_flightdetail_tuigaiguize":"Policies",
	"order_flight_flightorderinfo_dancheng":"one-way trip",
	"order_flight_flightorderinfo_weibeizhengce":"Violating policy",
	"order_flight_flightorderinfo_gongxiang":"shared",
	"order_flight_flightorderinfo_nianyueri":"YYYY-MM-DD",
	"order_flight_flightorderinfo_tuigaiguize":"Policies",
	"order_flight_flightorderinfo_yiquxiao":"cancelled",
	"order_flight_flightorderinfo_weibeizhengceyuanyin":"Reasons of Violating policy",
	"order_flight_flightorderinfo_quchuli":"To deal with",
	"order_flight_flightorderinfo_fuhezhengcedingdanshenpi":"conforming policy order approval",
	"order_flight_flightorderinfo_gaiqian":"change",
	"order_flight_flightorderinfo_tuipiao":"refund",
	"order_flight_flightorderinfo_quxiaotuipiao":"Cancel refund",
	"order_flight_flightorderinfo_quxiaogaiqian":"Cancel change",
	"order_flight_flightorderinfo_quxiaodingdan":"cancel order",
	"order_flight_flightorderinfo_shenpi":"approve",
	"order_flight_flightorderinfo_shenqingren":"applicant",
	"order_flight_flightorderinfo_gaiqianren":"passenger",
	"order_flight_flightorderinfo_gaiqianyuanyin":"reason to change",
	"order_flight_flightorderinfo_xiangqingyuanyin":"reason",
	"order_flight_flightorderinfo_jiazaizhong":"Processing",
	"order_flight_flightorderinfo_yunxutuipiao":"cancellations permitted",
	"order_flight_flightorderinfo_jujuetuipiao":"Non-refundable",
	"order_flight_flightorderinfo_yunxugaiqian":"changes permitted",
	"order_flight_flightorderinfo_jujuegaiqian":"Non-changeable",
	"order_flight_flightorderinfo_shenpitongguo":"Approved",
	"order_flight_flightorderinfo_shenpijujue":"rejected",
	"order_hotel_hoteldetail_wan":"night",
	"order_hotel_hoteldetail_tuigaixiangqing":"policies details",
	"order_hotel_hoteldetail_ri":"day",
	"order_hotel_hoteldetail_yi":"one ",
	"order_hotel_hoteldetail_er":"two",
	"order_hotel_hoteldetail_san":"three",
	"order_hotel_hoteldetail_si":"four",
	"order_hotel_hoteldetail_wu":"five",
	"order_hotel_hoteldetail_liu":"six",
	"order_hotel_hoteldetail_zhou":"week",
	"order_hotel_hoteldetail_wuzao":"breakfast is not included",
	"order_hotel_hotelorderinfo_yueri":"MM-DD",
	"order_hotel_hotelorderinfo_jian": "Rooms",
	"order_hotel_hotelorderinfo_wan":"night",
	"order_hotel_hotelorderinfo_weibeizhengce":"Violating policy",
	"order_hotel_hotelorderinfo_jiudianxiangqing":"Hotel Description",
	"order_hotel_hotelorderinfo_tuigaiguize":"Policies",
	"order_hotel_hotelorderinfo_yiquxiao":"cancelled",
	"order_hotel_hotelorderinfo_wozhidaoliao":"I see",
	"order_hotel_hotelorderinfo_weibeizhengceyuanyin":"Reasons of Violating policy",
	"order_hotel_hotelorderinfo_quchuli":"To deal with",
	"order_hotel_hotelorderinfo_fuhezhengcedingdanshenpi":"conforming policy order approval",
	"order_hotel_hotelorderinfo_shenqingtuifang":"Apply to cancel reservation",
	"order_hotel_hotelorderinfo_quxiaotuifang":"cancel reservation cancellation",
	"order_hotel_hotelorderinfo_quxiaodingdan":"cancel order",
	"order_hotel_hotelorderinfo_shenpi":"approval",
	"order_hotel_hotelorderinfo_shenqingren":"applicant",
	"order_hotel_hotelorderinfo_gaiqianren":"passenger",
	"order_hotel_hotelorderinfo_gaiqianyuanyin":"reason to change",
	"order_hotel_hotelorderinfo_wuzao":"breakfast is not included",
	"order_orderdetails_dingdanxiangqing":"order detail",
	"order_orderdetails_dingdanhao":"order no.",
	"order_orderdetails_ruzhurenxinxi":"guest info",
	"order_orderdetails_chuhangrenxinxi":"passenger info",
	"order_orderdetails_shouji":"telephone",
	"order_orderdetails_shanglvxinxi":"business travel information",
	"order_orderdetails_chengbenzhongxin":"cost center",
	"order_orderdetails_chalvmudi":"travel purpose",
	"order_orderdetails_chuchaishiyou": "business trip purpose",
	"order_orderdetails_xiangmudaima":"project code",
	"order_orderdetails_lianxiren":"Contact Info",
	"order_orderdetails_xingming":"name",
	"order_orderdetails_youxiang":"email address",
	"order_orderdetails_xuqiubeizhu":"requirements notes",
	"order_orderdetails_fujianxinxi": "Attachment Info",
	"order_orderdetails_fujianmingcheng": "Attachment Name",
	"order_orderdetails_caozuo":"Operate",
	"order_orderdetails_w":"five",
	"order_orderdetails_koukuanshuoming":"Deduction instructions",
	"order_orderdetails_hgjndfkfsjhysqhkcffr":"According to the payment method we will pre-authorize your card or deduct room fee. If the order is not confirmed, we will release the pre-authorization or give you a full refund to your account. The order can't be changed or cancelled. You will be billed for the first night's room charge if you don't check in. If you check out in advance you will be billed for the day's room charge.",
	"order_orderdetails_tebietishi":"Special Requests",
	"order_orderdetails_gjddrzsjwtfbzjssjwrt":"The earliest check-in time is 14:00. The check-out time is 12:00. If you arrive before this time or departure after this time, you may need subject to a fee.",
	"order_orderdetails_zongji":"Total",
	"order_orderdetails_mingxi":"Details",
	"order_orderdetails_feiyongmingxi":"Price Details",
	"order_orderdetails_baoxianfei":"insurance premiums",
	"order_orderdetails_fuwufei":"Service charge",
	"order_orderdetails_zonge":"Total",
	"order_orderdetails_tuigaiguize":"Policies",
	"order_orderdetails_ri":"Sunday",
	"order_orderdetails_yi":"monday",
	"order_orderdetails_er":"Tuesday",
	"order_orderdetails_san":"Wednesday",
	"order_orderdetails_si":"Thursday",
	"order_orderdetails_liu":"Saturday",
	"order_orderdetails_zhou":"week",
	"order_orderlist_wodedingdan":"my booking",
	"order_orderlist_meiyougengduoliao":"no more",
	"order_orderlist_yudingshijian":"Order time",
	"order_orderlist_weibeizhengce":"Violating policy",
	"order_orderlist_fuhezhengce":"conform to rules",
	"order_orderlist_chufa":"departure",
	"order_orderlist_zhi":"from",
	"order_orderlist_wei":"to",
	"order_orderlist_yuding":"book",
	"order_orderlist_yueri":"MM-DD",
	"order_orderlist_jipiao":"ticket",
	"order_orderlist_jiudian":"hotel",
	"order_orderlist_huoche":"train",
	"order_train_traindetail_di":"",
	"order_train_traindetail_cheng":"trip",
	"order_train_traindetail_yueri":"MM-DD",
	"order_train_traindetail_tuigaiguize":"Policies",
	"order_train_trainorderinfo_dancheng":"one-way trip",
	"order_train_trainorderinfo_weibeizhengce":"Violating policy",
	"order_train_trainorderinfo_gongxiang":"shared",
	"order_train_trainorderinfo_jianpiaokou":"gate",
	"order_train_trainorderinfo_zhida":"non-stop",
	"order_train_trainorderinfo_zongyongshi":"total duration",
	"order_train_trainorderinfo_nianyueri":"YYYY-MM-DD",
	"order_train_trainorderinfo_tuigaiguize":"Policies",
	"order_train_trainorderinfo_yiquxiao":"cancelled",
	"order_train_trainorderinfo_tuipiaoshuoming":"Refund instructions",
	"order_train_trainorderinfo_dgcgwqpqfcqsjdyfzkjr":"1.Book successfully. If the ticket is not collected or the time before departure is more than 35 minutes, you can enter “my booking”to apply for refund according to the prompt; refund within 15 days before departure, the Railway Bureau will charge a refund fee for each ticket on a ladder basis.",
	"order_train_trainorderinfo_dgcgyqphfcqsjxyfzxnz":"2.Book successfully. If tickets have been collected or the time before departure is less than 35 minutes, you should bring the passenger’s original valid certificate and the train ticket to the railway station refund window before departure.",
	"order_train_trainorderinfo_gaiqianshuoming":"Change instructions",
	"order_train_trainorderinfo_wqzzpqlfcsjdyfzkgqdy":"1.If the ticket is not collected or the time before departure is more than 35 minutes, the tickets can be changed to the train equal to or less than the original fare.",
	"order_train_trainorderinfo_kcqxsyskgqysqndcckcq":"2.More than 48 hours before the departure time, you can change the train of pre-sale period. Within 48 hours before the departure time, you can change your tickets to any train before 24:00 on the day. The tickets cannot be changed to the train on the day after the date of the original one.",
	"order_train_trainorderinfo_xcppjdyycpdthcédcébf":"3.If the new ticket price is lower than the original ticket, the difference shall be returned. And the refund fee for the difference shall be collected and the current refund fee standards shall be implemented.",
	"order_train_trainorderinfo_wozhidaoliao":"I see",
	"order_train_trainorderinfo_weibeizhengceyuanyin":"Reasons of Violating policy",
	"order_train_trainorderinfo_quchuli":"To deal with",
	"order_train_trainorderinfo_fuhezhengcedingdanshenpi":"conforming policy order approval",
	"order_train_trainorderinfo_gaiqian":"change",
	"order_train_trainorderinfo_tuipiao":"refund",
	"order_train_trainorderinfo_quxiaotuipiao":"Cancel refund",
	"order_train_trainorderinfo_quxiaogaiqian":"Cancel change",
	"order_train_trainorderinfo_quxiaodingdan":"cancel order",
	"order_train_trainorderinfo_shenpi":"approve",
	"order_train_trainorderinfo_shenqingren":"applicant",
	"order_train_trainorderinfo_gaiqianren":"passenger",
	"order_train_trainorderinfo_gaiqianyuanyin":"reason to change",
	"order_train_trainorderinfo_xiangqingyuanyin":"reason",
	"system_newaddress_shezhimorendizhi":"Processing",
	"system_newaddress_shanchu":"delete",
	"system_about_about_lichengshanglv":"Licheng Business Trip",
	"system_approvalset_provisionalauthorization_linshishenpishouquan":"Temporary approval authorization",
	"system_approvalset_provisionalauthorization_qingxuanze":"please select",
	"system_approvalset_provisionalauthorization_shouquanyuangong":"Authorized employees",
	"system_approvalset_provisionalauthorization_kaishiriqi":"start date ",
	"system_approvalset_provisionalauthorization_xuanzeshijian":"select time",
	"system_approvalset_provisionalauthorization_jiezhishijian":"end date ",
	"system_approvalset_provisionalauthorization_shouquanshichang":"Authorized time",
	"system_approvalset_provisionalauthorization_xiaoshi":"hour",
	"system_approvalset_provisionalauthorization_tian":"day",
	"system_approvalset_provisionalauthorization_shi":"hour",
	"system_approvalset_list_baocun":"save",
	"system_approvalset_list_shouquanliebiao":"Authorization list",
	"system_approvalset_list_yijianqingchu":"clear",
	"system_approvalset_list_yiguoqi":"expired",
	"system_approvalset_list_shouquanzhong":"Authorized",
	"system_approvalset_list_quxiaoxiugai":"Cancel change",
	"system_approvalset_list_qingxuanzeshouquanyuangong":"Please select authorized employees",
	"system_autoupdate_autoupdate_faxianxinbanben":"New version found",
	"system_autoupdate_autoupdate_xinzeng":"add",
	"system_autoupdate_autoupdate_lijigengxin":"update now",
	"system_configinfo_configinfo_baocun":"save",
	"system_configinfo_configinfo_peizhiguanli":"Configuration management",
	"system_configinfo_configinfo_youxiang":"email",
	"system_configinfo_configinfo_weixin":"wechat",
	"system_configinfo_configinfo_daishenpi":"awaiting approval",
	"system_configinfo_configinfo_daiqueren":"to be confirmed",
	"system_configinfo_configinfo_daizhifu":"to be paid",
	"system_configinfo_configinfo_daichuli":"to be processed",
	"system_configinfo_configinfo_yiwancheng":"completed",
	"system_configinfo_configinfo_baocunchenggong":"save successfully",
	"system_download_download_banbenhao":"version number",
	"system_download_download_daxiao":"size",
	"system_download_download_jieshao":"Introduction",
	"system_download_download_yingyongjieshao":"Introduction to the Applications ",
	"system_download_download_slcglqxdqyslglxtykqd":"This APP is a corporate business travel management system under Licheng International Travel Company, which is relying on powerful resources, advanced technology, high-quality services and professional management to help many companies optimize business travel, booking and authorization approval procedures.",
	"system_download_download_yonghukeyitongguo":"Users can",
	"system_download_download_xtksdjhjpjdhcpdcxyds":"quickly do inquiries, reservations, approvals and other services of air tickets, hotels, and train tickets through the APP system, which can make travel management intelligent. So that users do not need borrow money, advance funds, or reimburse travel expenses which can improve user travel satisfaction degree. It truly helps companies reduce consumption costs, simplify the financial reimbursement process, and improve operational efficiency.",
	"system_download_download_zhuyaogongneng":"",
	"system_download_download_àcsrqqfsjdxxcxbydjpj":"search and book air tickets, hotels, and train tickets by city, date, departure time and other information;",
	"system_download_download_qyyjdpwxygdkjkdphsxy":"Enterprise monthly ticket book (without employee advance payment) and authorize employee management",
	"system_download_download_qingsongchakanguanlidingdanyijiantuipiaogaiqian":"Easily view and manage orders, one-click refund and change;",
	"system_download_download_zcqydcbgkszydgczlhgk":"Support the enterprise's different standard control management. flexible control during the booking process. Help companies implementing travel policies and save costs.",
	"system_feedback_feedback_fankuileixing":"Feedback type",
	"system_feedback_feedback_fankuineirong":"Feedback content",
	"system_feedback_feedback_wltgwmdfwhzlwmwntgfw":"In order to improve our service and quality, we provide you with a dedicated channel for service complaints and suggestions. Feedback to our BOSS as soon as possible!",
	"system_feedback_feedback_shangchuanzhaopian":"upload photos",
	"system_feedback_feedback_shangchuantupianshuomingkeyigengfangbianwomenlijienindexuqiuo":"Uploading a picture description can make it easier for us to understand your needs",
	"system_feedback_feedback_yibianwomengeininhuifu":"So that we can reply to you",
	"system_feedback_feedback_shoujihao":"telephone no.",
	"system_feedback_feedback_qitalianxifangshiyouxiang":"Other contact information (email/QQ...)",
	"system_feedback_feedback_qita":"other",
	"system_feedback_feedback_tijiao":"submit",
	"system_feedback_feedback_yijianfankui":"Feedback",
	"system_feedback_feedback_shijuetiyan":"Visual experience",
	"system_feedback_feedback_caozuotiyan":"Operation experience",
	"system_feedback_feedback_zhengzaishangchuan":"uploading ",
	"system_feedback_feedback_shangchuanchenggong":"Upload successfully",
	"system_feedback_feedback_shangchuanshibai":"upload failed",
	"system_feedback_feedback_qingtianxienindebaoguiyijianhuoshangchuanzhaopian":"Please fill in your valuable comments or upload photos",
	"system_feedback_feedback_tijiaochenggongganxienindefankui":"The submission is successful, thank you for your feedback",
	"system_mall_addinvoice_shanchu":"delete",
	"system_mall_addtraveller_shanchu":"delete",
	"system_mall_modules_travelername_xingmingxuyuxiedaichuhangdezhengjianyizhifouzehuiyingxianghangcheng":"The name must be consistent with the travel documents, otherwise it will affect the itinerary",
	"system_mall_modules_travelername_tianxiexuzhi":"Notes",
	"system_mall_modules_travelername_yitianxieshuoming":"Instruction",
	"system_mall_modules_travelername_chengkexingmingxuyudengjisuochizhengjianshangdemingziyizhi":"The passenger's name must be consistent with the travel documents",
	"system_mall_modules_travelername_wqbslchqqblhjsrqzsbz":"To ensure a successful trip, please make sure that the end date of the trip is at least 6 months earlier than the validity of the document. Please confirm to fill in the true and valid document number. The order cannot be modified after submitted.",
	"system_mall_modules_travelername_erxinbanhuzhao":"current passport",
	"system_mall_modules_travelername_sanjiubanhuzhao":"expired passport",
	"system_mall_modules_travelername_sigangaotonghangzheng":"Mainland Travel Permit for Hong Kong and Macau Residents",
	"system_mall_modules_travelername_wutaiwantonghangzheng":"Mainland Residents Traveling to Taiwan Permit",
	"system_mall_modules_travelername_liutaibaozheng":"Mainland Travel Permit for Taiwan Residents",
	"system_mall_oftenpassenger_gongsichangke":"company frequent guest",
	"system_mall_oftenpassenger_gerenchangke":"personal frequent guest",
	"system_messagenotify_messagenotify_gong":"total",
	"system_messagenotify_messagenotify_tiaoxiaoxi":"",
	"system_messagenotify_messagenotify_weiduxiaoxi":"unread message",
	"system_messagenotify_messagenotify_yiduxiaoxi":"read message",
	"system_messagenotify_messagenotify_zanwuxiaoxi":"no message",
	"system_messagenotify_messagenotify_xiaoxitongzhi":"message notification",
	"system_messagenotify_messagenotify_quanbuxiaoxi":"total",
	"system_messagenotify_messagenotify_xitongtongzhi":"systematic notification",
	"system_messagenotify_messagenotify_xiaoxitixing":"message reminding",
	"system_messagenotify_notifyitem_xitongtongzhi":"systematic notification",
	"system_messagenotify_notifyitem_xiaoxitixing":"message reminding",
	"system_messagenotify_notifyitem_ganggang":"just now",
	"system_messagenotify_notifyitem_shanchu":"delete",
	"system_modules_calendar_zhongzhi":"reset",
	"system_modules_calendar_ri":"Sunday",
	"system_modules_calendar_yi":"monday",
	"system_modules_calendar_er":"Tuesday",
	"system_modules_calendar_san":"Wednesday",
	"system_modules_calendar_si":"Thursday",
	"system_modules_calendar_wu":"Friday",
	"system_modules_calendar_liu":"Saturday",
	"system_modules_calendar_yuandan":"New Year's Day",
	"system_modules_calendar_qingmingjie":"Ching Ming Festival",
	"system_modules_calendar_laodongjie":"Labor day",
	"system_modules_calendar_guoqingjie":"National Day",
	"system_modules_calendar_chuxi":"Chinese New Year's Eve",
	"system_modules_calendar_chunjie":"Spring Festival",
	"system_modules_calendar_duanwujie":"Dragon Boat Festival",
	"system_modules_calendar_zhongqiujie":"Mid-Autumn Festival",
	"system_user_account_account_jiebang":"unbind",
	"system_user_businessregister_qiyeyonghuzhuce":"Enterprise user registration",
	"system_user_businessregister_ruguigongsiyishilichengshanglvqianyueqiye":"If your company is the contracted enterprise of Licheng Business Trip",
	"system_user_businessregister_qinglianxinindechalvfuzerenhuoquzhanghaowuzhongfuzhuce":"Please contact the person in charge of business travel to obtain an account, do not register repeatedly",
	"system_user_businessregister_qingshuruninqiyemingcheng":"Please enter your company name",
	"system_user_businessregister_qiyemingcheng":"company name",
	"system_user_businessregister_shoujihaohuoyouxiangzhuce":"telephone number or email registration",
	"system_user_businessregister_shoujihao":"telephone number",
	"system_user_businessregister_qingshuruyanzhengma":"please enter verification code",
	"system_user_businessregister_yanzhengma":"verification code",
	"system_user_businessregister_qingshuruguiqiyesuoshuhangye":"Please enter the industry of your company",
	"system_user_businessregister_qiyehangye":"company Industry",
	"system_user_businessregister_qingshuruguiqiyediqu":"Please enter your company address",
	"system_user_businessregister_qiyediqu":"company address",
	"system_user_businessregister_qingtianxielianxirenxingming":"Please enter the contact name",
	"system_user_businessregister_lianxiren":"the contact name",
	"system_user_businessregister_zhucezhanghao":"Register an account",
	"system_user_businessregister_qingshezhidenglumima":"Please set password",
	"system_user_businessregister_denglumima":"password",
	"system_user_businessregister_zaicishurumima":"enter the passphrase again",
	"system_user_businessregister_querenmima":"Confirm Password",
	"system_user_businessregister_tongyi":"agree",
	"system_user_businessregister_fuwuxieyi":"Service Agreement",
	"system_user_businessregister_xiayibuyanzheng":"Next, verify",
	"system_user_businessregister_wancheng":"complete",
	"system_user_businessregister_ruzhucechuxianwenti":"If there is any problem with registration",
	"system_user_businessregister_qingboda":"Please ",
	"system_user_businessregister_lianxikefuweinijieda":"Contact customer service to answer for you",
	"system_user_businessregister_zhuce":"registered",
	"system_user_businessregister_gongsimingchengbunengkong":"Company name cannot be empty",
	"system_user_businessregister_dangqianshoujihaoyibeizhuce":"The current mobile phone number has been registered",
	"system_user_main_peizhiguanli":"Configuration management",
	"system_user_modules_authorizat_qiyezhanghaoyouxiangshoujihao":"Enterprise account/email/phone number",
	"system_user_modules_authorizat_qingshuruzhanghu":"Please enter account",
	"system_user_modules_authorizat_buqufendaxiaoxie":"case-insensitive",
	"system_user_modules_authorizat_qingshuruyanzhengma":"please enter verification code",
	"system_user_modules_authorizat_lijibangding":"Bind now",
	"system_user_modules_authorizat_lijizhuce":"register now",
	"system_user_modules_authorizat_zhanghaobangding":"Account binding",
	"system_user_modules_authorizat_shoujiyanzhengbangding":"mobile phone binding verification",
	"system_user_modules_ordinary_lijizhuce":"sign in",
	"system_user_modules_ordinary_denglu":"register",
	"system_user_modules_ordinary_xiugaichushimima":"change initial password",
	"system_user_modules_password_shezhimima":"set password",
	"system_user_modules_password_xiacidenglutixingwo":"Remind me the next time I log in",
	"user_resetpwd_mobilevalidate_yanzhengguize":"Validation rules",
	"user_resetpwd_verifyidentity_zhaohuimima":"Retrieve password",
	"user_resetpwd_verifyidentity_dengluming":"login name",
	"user_resetpwd_verifyidentity_zhucehuobangdingdeshoujihaohuoyouxiang":"Registered or bound mobile phone number or email",
	"user_resetpwd_verifyidentity_haiwaishoujiqinganguojiadaimashoujihaomadegeshishururu":`For overseas mobile phones, please enter the format of "country code-mobile phone number", such as: 79-66666666`,
	"user_resetpwd_verifyidentity_xiayibu":"Next step",

  user:{
    companyName:'Licheng Business Trip'
  },
  router:{
    home:"Home",
    trip:"trip",
    my:"My ",
  },
  bill:{
    myOrder:'my booking'
  },
  mall: {
    OnBusiness:"For business",
    OnPersonal:"for personal",
    btriprule:"Travel rules",
    demandorder:"Demand list",
    allprice:"Full price",
    discount:"off",
    GivenName:"English given name",
    Surname:"English Surname",
    selectedseat:"Seat selected",
    noselectseat:"seat Unselected",
    takeOff:"t,ake off",
    FillInfo:"Fill in instructions",
    ExpiryDate:"validity",
    StartTime:"Starting time",
    EndTime:"End Time",
    ToProcessDate:"Departure date",
    backTracking:"Return date",
    sharing:"shared",
    AirplaneModelTxt:"Airplane Model",
    ticketfeeFloat:"This price does not include airport construction fee and tax",
    peopleTypeExplain:"booking instructions of Child and infant ",
    bookingTicketExplain:"If you need to book a child or infant ticket, please contact our customer service.",
    onlySeeDirect:"only direct flights",
    hiddenSharedFlight:"Hide shared flights",
    ActualCarrier:"Actual carrier",
    stayTxt:"stop",
    turnTxt:"Transfer in",
    priceRemarks:"The following charge is the average price of an adult or a child or an infant.",
    AgreementPrice:"business Recommendation",
    tax:"tax",
    trainHolderKeyWords:"Domestic train ticket",
    bookingRemarks:"You can only book a maximum of 5 passengers at a time",
    beginTxt:"Departure",
    passTxt:"Pass",
    endTxt:"Arrival",
    StandingOrder:"Station order",
    stationName:"Station name",
    arrivalTimeTxt:"Arrival time",
    departTimeTxt:"Departure time",
    departDate:"Departure date",
    arrivalDate:"Arrival date",
    hotelHolderKeyWords:"Please enter keywords/hotel name, etc.",
    HotelRemarks:"Please do not book over 5 rooms or 20 nights. If you have special needs please contact with customer service.",
    TrainRemarks:"NOTICE: Booking time is from 7:30 am to 22:30 pm. You can book,change and refund tickets more than 30 minutes prior to departure. The tickets within 24 hours should be paid in 10 minutes. The tickets beyond 24 hours should be paid in 25 minutes.",
    NoTrainSearch:"We don't provide train service in the current time",
    mapTxt:"map/navigation",
    detailsOrFacilities:"Details/Amenities",
    noSooner:"No breakfast",
    breakfast:"breakfast",
    breakfastTxt:"With breakfast",
    noCancellation:"Non-refundable",
    timeToCancel:"free cancellation before 具体时间",
    RoomsTxt:"number of rooms",
    hotelUnit:"late",
    checkInTxt:"Check in",
    checkOutTxt:"Check out",
    checkInDate:"Check-in date",
    checkOutDate:"Check out date",
    Frequenter:"frequent guest",
    Temporary:"temporary guest",
    TemporaryInformation:"temporary guest information",
    addFrequenter:"add frequent guest",
    addTemporary:"add temporary guest",
    TravelStandard:"Traveling Expenses Standard",
    hightToLow:"high to low",
    lowToHight:"low to high",
    morningToNight:"earliest to latest",
    nightToMorning:"latest to earliest",
    starLevelTxt:"star rating",
    filtrateTxt:"filter",
    timeTxt:"time",
    fromTo:"from",
    portion:"",
    contactNumber:"contact Number",
    conformToRules:"conforming policy ",
    breakToRules:"Violating policy",
    unlimited:"no limitation",
    beforeDay:"the previous day",
    afterDay:"the following day",
    adequateTxt:"enough",
    Remaining:"only 数字 left",
    taxesTxt:"tax",
    BackTorule:"policies",
    trainamendrule:'15+ days prior to departure: free 48 hours-15 days prior to departure: 5% of ticket price 24-48 hours prior to departure: 10% of ticket price Within 25 hours before departure: 20% of ticket price.',
    booking:"book",
    onlinePay:"prepay online",
    departTxt:"Departure",
    arrivalTxt:"Arrival",
    sheet:"ticket",
    NoTicket:"sold out",
    orderFilltitle:"Order filling",
    tripInfosTitle:"passenger information",
    BookingInformation:"Booking notice",
    tripInfosRemarks:"To ensure a successful trip，please make sure that the passenger's name must be consistent with the travel documents",
    addTraveller:"Add a passenger",
    UserName:"Name",
    contactInfosTitle:"contact information",
    RemarkInfosTitle:"note",
    contacts:"Contact person",
    Phone:"telephone",
    Email:"e-mail",
    InstructTitle:"Deduction instructions",
    InstructContent:"According to the payment method we will pre-authorize your card or deduct room fee. If the order is not confirmed, we will release the pre-authorization or give you a full refund to your account. The order can't be changed or cancelled. You will be billed for the first night's room charge if you don't check in. If you check out in advance you will be billed for the day's room charge.",
    SpecialTipsTitle:"Special Requests",
    SpecialTipsContent:"The earliest check-in time is 14:00. The check-out time is 12:00. If you arrive before this time or departure after this time, you may need subject to a fee.",
    travelInformationTitle:"travel information",
    CostCenter:"cost center",
    TravelPurpose:"travel purpose",
    ProjectCode:"project code",
    contraryReason:"reason of violations",
    ViolateTravelRules:"Violating travel rules",
    SpecialRequirement:"Special needs",
    SpecialRequirementTips:"Special needs remarks",
    specialRequirementContent:"We will try our best to coordinate with your special requirements. If it cannot be satisfied, we will not notify you separately, please understand",
    otherRequirement:"other demands",
    consentAgreement:"Click Submit means that you have read and agreed",
    importantTerms:"Booking instructions and important terms",
    BookingHint:"In order to support the green environmental protection, be default we provide electronic contract. If you need to sign a paper contract, please call customer service.",
    CostDetails:"price Details",
    payTotalPrice:"Total",
    totalPrice:"Total",
    roomUnit:"room",
    nightUnit:"night",
    peopleUnit:"person",
    details:"Details",
    CustomerService:"Contact Customer Service",
    SubmissionOrPayment:"Submit/Pay",
    frequentlnformationTitle:"Passenger information",
    TravellerTitle:"Passenger Name",
    EnglishName:"English name",
    LastName:"English Surname",
    firstName:"English given name",
    NameOrIdCardTips:"To ensure a successful trip，please make sure that the passenger's name must be consistent with the travel documents",
    CertificateInformatTitle:"ID informaiton",
    ExpireDate:"ID validity",
    otherInfosTitle:"other information",
    Sex:"gender",
    Birthday:"date of birth",
    Nationality:"Nationality",
    optionalCard:"frequent flyer card (optional)",
    reminderInfos:"To ensure a successful trip, please make sure that the end date of the trip is at least 6 months earlier than the validity of the document. Please confirm to fill in the true and valid document number. The order cannot be modified after submitted.",
    addOrEditTraveller:"Add or edit passenger",
    AllOrder:"All orders",
    orderStatus:"Order Status",
    departTime:"departure time",
    orderDetail:"order details",
    CancelOrder:"cancel order",
    CancelRefund:"Cancel refund",
    CancelChange:"Cancel change",
    ApprovalRefused:"rejected",
    ApproveSucc:"Approved",
    PayNow:"pay now",
    Refund:"Refund",
    RefundHotel:"check out",
    RefundGroup:"refund group",
    Change:"Change",
    SubmitOrder:"Submit Order",
    PriceDetail:"Price details",
    CheckOrderProgress:"check order progress",
    flightInformation:"flight information",
    orderNumber:"order number",
    BookingTime:"Booking time",
    First:"序数",
    Journey:"trip",
    few:"room",
    Level:"level",
    BackToChangeTips:"The final amount is subject to review. If you have any questions, please call customer service",
    pleaseChoose:"please choose",
    ThePassengers:"ThePassengers",
    Transfer:"Stopover",
    Flight:"flight",
    RefundRoomsDate:"Check out time",
    TheReason:" reason",
    TheTrain:"train",
    hour:"hour",
    minute:"minute",
    Gym:"Gym",
    district:"administrative area",
    business:"administrative area",
    ThePassengerInformation:"Passenger information",
    NewTrainInformation:"New train information",
    OriginalTrainInformation:"Original train information",
    NewFlightInformation:"New flight information",
    OriginalFlightInformation:"Original flight information",
    NextStep:"Next step",
    ChangeDate:"Change date",
    SelectChangeFlight:"Please select a changed flight",
    SelectRefundFlight:"Please select the flight for refund",
    SelectChangeTrain:"Please select the changed passenger",
    SelectRefundTrain:"Please select the refunded passenger",
    SelectRefundHotel:"Please select the hotel to check out",
    SelectChangeDate:"Please select a date to change",
    Department:"department",
    ApprovalStatus:"Approval Status",
    ConfidentialInformation:"Credential information",
    TradeInformation:"Trading Information",
    Insurance:"Insurance",
    Home:"Home",
    Stroke:"trip",
    Me:"my",
    TravelApproval:"Travel approval",
    TravelRulesName:"Travel rules",
    MinimumPriceBase:"lowest price standard",
    RealFlightControl:"management of real time flight",
    AdvanceBookingTime:"advanced booking time",
    ClassLimit:"Class limitation",
    SeatClassLimit:"Class limitation",
    AgreementAirlinePriority:"contract tickets first",
    AgreementHotelPriority:"Contract hotels first",
    MaximumAmountConsumption:"upper limitation of consumption",
    ApprovalName:"Travel rules",
    Other:"other",
    FirstClassCity:"first-tier city",
    SecondaryCity:"second-tier city",
    ThreeLevelCity:"third-tier city",
    SeatSelectionService:"seat select",
    Bezel:"window",
    Aisle:"aisle",
    NewContacts:"Add contact",
    AdditionalInvoiceInformation:"Add/Edit invoice information",
    InvoiceInformation:"Invoice Information",
    InvoiceTitle:"Invoice",
    TariffItem:"Tax number",
    SetDefaultContacts:"Set default contact",
    ConsigneeAddress:"Recipient address",
    NewCommonAddresses:"Add frequently used addresses",
    default:"default",
    City:"city",
    Address:"address",
    Postcode:"Postcode",
    AddCommonAddresses:"Add/Edit frequently used addresses",
    DepartureTime:"departure time",
    Airport:"airport",
    ShippingSpace:"class ",
    AirlineCompany:"airline",
    '150OrLess':"less than 150",
    '150And300':"￥150-300",
    '300And450':"￥300-450",
    '450And600':"￥450-600",
    '600OrMore':"more than 600",
    TwoStarsOrLess:"two stars and below",
    ThreeStar:"Three stars / comfortable",
    FourStar:"Four stars / upscale",
    FivesStar:"Five stars / luxurious",
    Apartment:"Apartment",
    Inn:"Inn",
    FamilyInn:"family Inn",
    YouthHostel:"Youth Hostel",
    CoupleHotel:"Love hotel",
    GardenCourtyard:"Garden courtyard",
    SeaView:"Sea view",
    Farmhouse:"Farmhouse",
    HotSpringHotel:"Hot Spring Hotel",
    GolfHotel:"Golf Hotel",
    Siheyuan:"Courtyard",
    Villa:"villa",
    PartyCooking:"Party cooking",
    BusinessTtravelHome:"Business Travel Home",
    LeisureMood:"Casual mood",
    SeeDoctor:"see doctor",
    VacationLeisure:"Vacation leisure",
    TrainAndLearn:"Training and learning",
    GetTogether:"party ",
    HoneymoonTrip:"Honeymoon",
    boutiqueHotel:"Boutique Hotel (Designer Hotel)",
    FreeWifi:"Free wifi",
    FreeParking:"Free parking lot",
    IndoorPool:"indoor swimming pool",
    OutdoorPool:"Outdoor swimming pool",
    service:"Gym",
    BusinessCenter:"Business center",
    MeetingRoom:"meeting room",
    HotelRestaurant:"hotel restaurant",
    MorningCall:"morning Call",
    LuggageStorage:"Luggage storage",
    TwinBed:"Double bed",
    BigBed:"big bed",
    FreePickUpService:"Free pick-up service",
    Price:"price",
    StarLevel:"Star rating",
    Specialtie:"Features",
    Service:"Facilities",
    DetailsOrFacilities:"Details/Facilities",
    HotelDetail:"Hotel details",
    ModelSelection:"Model selection",
    HighSpeedRail:"High-speed train(G/C)",
    MotorCar:"High-speed train(D)",
    Ordinary:"common(Z/T/K)",
    DepartureOrArrival:"Departure/Arrival Station",
    Date:"date",
    Status:"status",
    OldSystem:"Please view by PC version ",
    Welcome:"Welcome",
    PleaseLogIn:"please sign in",
    FlightTips:"Low-cost air tickets, comfortable travel",
    HotelTips:"Exclusive stay, exclusive for business travel",
    TrainTips:"One-click lightning ticket issuance",
    TourTips:"Featured special offer tours",
    Invoice:"Invoice",
    InvoiceType:"invoice type",
    Identifier:"identifier",
    TicketInquiry:"Ticket inquiry",
    TrainInquiry:"Train inquiry",
    HotelInquiry:"Hotel inquiry",
    ConsumerHotline:"Customer Service",
    WeChatService:"WeChat Customer Service",
    TravelPolicy:"Travel policy",
    EditData:"edit information",
    RecommendFlight:"Recommended flight",
	voyageinfos: "flight information",
	passinfos: "Passenger information",
    passnum: "Number of passengers",
	cabinlevel: "Class of cabin",
	consumertype: "Passenger Type",
	sui: "year old",
    twosui: "Under two years old",
    firstairway: "Preferred airline",
	demandprobtip: "If you have a problem with the submission, please consult:",
	submit: "submit",
	remark: "remark",
	email: "email",
	contact: "Contact person",
	phoneno: "Mobile",
	contactinfo: "Contact info",
	normal: "ordinary",
    student: "student",
    newimmigrant: "New immigrants",
    worker: "laborservice",
	adult: "adult",
    child: "child",
    infant: "baby",
	departdate: "Departure time",
    arrivedate: "arr time",
	departcity: "Departure City",
    arrivecity: "Arrival City",
	selectdate: "Select date",
	delete: "Delete",
	addvoyage: "Add flight",
	notificationMessageFlight:
	"Notice: if you need, you can click here to enter the international demand list.To meet any of your travel needs You may also call:",
	noVoyage:'Voyage without satisfaction？',
	foundRequirement:'Create requirement sheet',
	Hotline: "Hotline consultation.",
    OriginalFlight:"Original flight",
    More:"More",
    MoreInfo:"More information",
    Hidden:"hide",
    JetFuel:"Including Airport construction fee",
    Booking:"Booking",
    CurrentPosition:"current position",
    Room:"room",
    SquareMeters:"Square meter",
    CanLive:"Can live",
    Floor:"floor",
    Layer:"Floor",
    ServiceFee:"Service charge",
    InsurancePremium:"insurance premiums",
    Yuan:"",
    ContactHotel:"contact hotel",
    After:"after",
    Before:"before",
    For:"for",
    DueTo:"Booked at",
    ViolationPolicy:"Violating policy",
    CompliancePolicy:"conforming policy ",
    BusinessInformation:"Business Travel Information",
    Within:"Within",
    RefuseReason:"Approval notes",
    Against:"violate",
    Policy:"Policy",
    DetailedReason:"reasons",
    Wait:"await",
    Approval:"Approve",
    Breach:"violate",
    AirlineAuditStandards:"Subject to the latest airline regulations, you can contact customer service ",
    ConfirmOrder:"Confirm Order",
    FlightInformation:"flight information",
    Voyage:"flight",
    DeparturePlace:"Departure",
    ArrivePlace:"Arrival",
    AddVoyage:"Add itinerary",
    PassengersNumbers:"Number of passengers",
    ShipType:"class type",
    PassengersType:"Passenger Type",
    ShipCompany:"Preferred Airlines",
    Remarks:"Remarks",
    PackUp:"show less",
    Show:"show more",
    DocumentType:"ID Type",
    CardNo:"id number",
    InvoiceRole:"Invoice role",
    BankName:"Bank name",
    BankAccount:"Bank Account",
    RegisteredAddress:"Registered address",
    RegisteredPhone:"Registered phone",
    ChangeReason:"reason of change",
    VoucherNumber:"Voucher number",
    CancelReason:"Reason of cancel",
    ChildInfantBooking:"Child and infant booking instructions",
    boyin:"Boeing",
    kongke:"Airbus",
    AppropriationBudget:"budget",
    Attendance:"Number of participants",
    HostPlace:"Host Place",
    Destination:"destination",
    ParticipantsNumber:"The number of participants",
    ActivityBudget:"Activity budget",
    AmountPaid:"Amount to be paid",
    ConfirmPayment:"confirm payment",
    Pay:"pay",
    PriceTxt:"price",
	ReserveHint:'It is a non-connecting flight. If one of the flights is changed, the passenger who needs to cancel the other flight will bear the corresponding cancellation fee.'
  },
  placeholders: {
    UserID:"please enter user name",
    Password:"Please enter password",
    UserPhone:"Please enter phone number",
    contacts:"Please fill in the contact name",
    Email:"Used to receive confirmation",
    CostCenter:"please select cost center",
    TravelPurpose:"please select the travel purpose",
    ProjectCode:"please enter project code",
    CauseName:"please choose the reason of violations",
    CauseDetails:"please write the details of violations reason",
    searchTraveller:"Please enter your name ",
    SearchZones:"Chinese or Pinyin for cities and stations",
    UserName:"match the passenger's ID name",
    LastName:"Such as: 张飞, fill in: ZHANG",
    firstName:"Such as: 张飞, fill in: FEI",
    CardNo:"ID number",
    Phone:"Please enter the phone number",
    RecipientAddress:"Please enter recipient address",
    RecipientPostcode:"Please enter the recipient's zip code",
    OriginalPassword:"Please enter the original password",
    NewPassword:"Please enter a new password",
    AffirmNewPassword:"Please confirm your password",
    CompanyName:"Please enter company name",
    SelectCity:"Please choose the city",
    Industry:"Please enter industry",
    Account:"Please enter your phone number or email",
    VerificationCode:"please enter verification code",
    DynamicCode:"Please enter dynamic code",
    RegisterPhone:"Please register or bind your mobile phone number!",
    Invoice:"Invoice",
    InvoiceType:"invoice type",
    Identifier:"Required, Taxpayer's registration number",
    RefusalCause:"Please enter the reason for rejection",
    CaseInsensitive:"case-insensitive",
    MessageAuthenticationCode:"message verification code",
    DeparturePlace:"Departure",
    ArrivePlace:"Arrival",
    ContactEmail:"please enter your email",
    Remarks:"Please enter note",
    ShipCompany:"Preferred Airlines",
    BankName:"Bank name",
    BankAccount:"Bank Account",
    RegisteredAddress:"Registered address",
    RegisteredPhone:"Register phone",
    TrainDetailReason:"Train details",
    PeopleNumber:"Please enter the number of people",
    AppropriationBudget:"Please enter budget",
    ContactNumber:"Please enter your phone number",
    ContactRemarks:"Tell us your most convenient contact time and method, and let us reply you at the most appropriate time.",
  },
  system: {
    Customer:"online service",
    EmailNotification:"E-mail notification",
    servicePhone:"",
    Company:"Licheng Business Trip",
    Name:"Licheng Business Trip",
    contacts:"Contact information",
    HowToCall:"What should everyone call you",
    PerfectInformation:"Please complete the mobile number",
    BindingPhone:"Bind phone",
    BindingEmail:"Bind mailbox",
    AccountAssociated:"Account association",
    UpdatePassword:"change login password",
    Language:"Language",
    Chinese:"Chinese",
		English:"English",
		Japanese:'Japanese',
    ExitLogin:"log out",
    WeChat:"WeChat",
    ImmediatelyBinding:"Bind now",
    Password:"password",
    OriginalPassword:"original password",
    NewPassword:"new password",
    AffirmNewPassword:"confirm password",
    ChangePassword:"change Password",
    EditPersonalInformation:"Edit profile",
    CompanyName:"Company Name",
    Industry:"industry",
    Account:"Account",
    VerificationCode:"Verification code",
    DynamicCode:"Dynamic code",
    RegisterNow:"register now",
    Register:"registered",
    UserRegister:"Individual registration",
    CompanyRegister:"Company registration",
    ServiceAgreement:'Agree to "Licheng Travel Service Agreement"',
    SendDynamicCode:"Send dynamic code",
    Sent:"Has been sent",
    LoginTxt:"sign in",
    DynamicPasswordLogin:"Dynamic password login",
    ForgetPassword:"forget password",
    Integral:"points",
    AllOrders:"All orders",
    Obligation:"Awaiting Payment",
    NotToTravel:"Upcoming",
    ToApproval:"awaiting approval",
    TicketInformation:"Ticket information",
    OrderInformation:"order information",
    OrderID:"Order number",
    TradeID:"Transaction number",
    TradeAmount:"The total amount of orders",
    CollectingCompany:"Receivables Company",
    PaymentWays:"payment method",
    Payment:"Pay",
    ThePassengerInformation:"Passenger information",
    PassWordLogin:"Password login",
    CodeLogin:"Verification code login",
    Notice:"Notice",
    RecentOrders:"Recent itinerary",
    Reserved:"awaiting confirmation",
    CustomerService:"Customer service",
    Sell:"Sales",
    ContactUs:"contact us",
    Call:"call",
    ServiceDept:"Customer Service Department",
    MyOrder:"my booking",
    ApprovalDispose:"Approval processing",
    RetrievePwd:"Easy to log in or retrieve password",
    ElectronicBills:"Easy to receive electronic bills",
    ApprovalAccredit:"Approval authorization",
    AboutUs:"about us",
    TestGetCode:"get verification code",
    PhoneHint:"You can reset the password through a valid binding mobile phone.",
    EmailHint:"You can reset the password through a valid bound email address.",
    LoginPassword:"login password",
    ResetPassword:"reset Password",
    EnterAccount:"enter account",
    PhoneVerification:"Phone verification",
    EmailVerification:"E-mail verification",
    SetBinding:"Set binding",
    Input:"enter",
    Effective:"Effective",
    Verify:"verification",
    NextStep:"Next step",
    RemarkString:"time limitation of Refund and change ",
    RefundFee:"Cancellation Fee ",
    Cabinfee:"Change Fee of same class",
    ReimburseInfo:"reimbursement information",
    BaggageAllowance:"Baggage Allowance",
    BackChangeRemark:"Cancellation and change policies are based on ticket type; any additional fees are determined by the airline",
    PartRoute:"some routes",
    PartHotel:"some hotels",
    IsSaveCustomers:"save to frequent guest or not",
    EmployeeRights:"Employee permissions",
    DateGranted:"Grant date",
    ExpiryDate:"Expiration date",
    AddApproval:"Add/modify approval",
    AddApprovals:"Add approval",
    DownloadInstall:"Download and install",
    TopRightCorner:"Please click on the upper right corner",
    BrowserOpen:"Select to open in browser",
    CannotDownloaded:"Cannot download apps in WeChat/QQ",
    CompanyProfile:"Company Overview",
    CompanyProfileContent:"the official website of Shanghai Lichengtrip (www.lichengtrip.net) is affiliated to Shanghai Lichengtrip Ticketing Co., Ltd. The company is headquartered in Shanghai, China. The headquarter office is located in Xindongfang International Business Center, Changning District, Shanghai which is close to Jingan Temple, Caojiadu and other business centers. The company has created call center, general manager's office, finance department, ticket settlement department, international department, domestic counterpart department, customer service department, training department, commerce department, operation center and other corresponding departments. It is a large-scale civil aviation service company with a wide range of sales, a large scale of service, and strong comprehensive strength in Shanghai.",
    FutureProspects:"future prospect",
    FutureProspectsContent:"In the 21st century with the rapid development of Internet technology, the business travel distribution system developed by Shanghai Licheng and scientific research units uses advanced technology with independent intellectual property rights to serve all aspects of people’s lives in the world with convenient and fast streamlined projects, allowing everyone to live on the Internet Ordinary people in the society have the opportunity to become the trend of the Internet economy. Make them feel the perfect integration of the excellent traditional culture of the Chinese nation and the modern democratic lifestyle in the online life experience every second, feel the real humanistic care and the continuous enrichment and improvement of material life, and promote the network society Healthy, harmonious and stable development, dedicated to all the enthusiasm and wisdom of Licheng people! 2016 is a time for Licheng to usher in a higher development. With innovation and enterprising as the driving force, we will further accelerate the speed of development and improve the quality of development. With international and domestic air ticket sales as the main body, vacation bookings are simultaneously implemented, the implementation of a comprehensive development strategy, and efforts to promote informatization, Build an information platform.",
    ManagementTeam:"Close and sophisticated management team",
    ManagementTeamContent:"The perfect combination of resource cooperation, management skills, and business experience of Shanghai Licheng's management team, as well as close and close cooperation between the teams, ensure the company's rapid and steady development. Our senior management team has gathered many years of experience in business operation and management in the international IT industry, tourism and financial industries; the middle management team has brought together China’s IT industry, aviation agency industry and tourism industry, ensuring the scale of services and resources Management policy.",
    TechnicalService:"Technology leadership and service",
    TechnicalServiceContent:"Licheng has always regarded technological innovation as the source of vitality for the company, and spared no effort in enhancing R&D capabilities. Licheng has established a complete set of modern service system, driven by innovation and enterprising, to further accelerate the speed of development and improve the quality of development, with international and domestic air ticket sales as the main body, hotel reservations and vacation bookings simultaneously.Licheng implement a comprehensive development strategy, strive to promote information And build an information platform.",
    AboutUsContent:"telephone",
  },
  share: {
    hot:"Popular recommend ",
    calendarDataTitle:"Select date",
    calendarDataExplain:"The query date is the departure date",
    cancelTxt:"cancel",
    confirmTxt:"confirm",
    pullUpLoadMoreTxt:"load more",
    pullUpLoadNoMoreTxt:"no more",
    RefreshTheSuccess:"Refresh successfully",
    Save:"save",
    Add:"Add ",
    QueryBtn:"search",
    SubmitBtn:"submit",
    AmendBtn:"modify",
    FinishBtn:"complete",
    fail: {
      CancelOrder:"Please choose to cancel the order",
      RefundOrder:"Please choose to cancel the refund order",
      selectTraveller:"Please select a passenger!",
      minPrice:"Your choice is not a recommended flight or class. Are you sure you want to continue booking?",
      CostCenter:"Please enter a cost center!",
      TravelPurpose:"Please enter the purpose of the trip!",
      EnglishName:"The passenger has no English name!",
      RefundJourney:"Please select the itinerary which you need to refund!",
      RefundReason:"Please select the reason you need to refund!",
      RefundTraveller:"Please select the passenger you need to refund!",
      ChangeJourney:"Please select the itinerary you need to change!",
      ChangeTraveller:"Please select the passenger you need to change!",
      ChooseAnotherFlight:"Please choose another airline's flight!",
      TheCorrectName:"Please enter the correct surname and given name!",
      UsreNameRepetition:"Passenger name cannot be repeated!",
      RegisterPhone:"Please register or bind your mobile phone number!",
      VerificationCode:"please enter verification code",
      DynamicCode:"Please enter dynamic code",
      PassengerSurname:"Please enter passenger surname",
      PassengerName:"Please enter passenger given name",
      RefusalCause:"Please fill in the reason for rejection!",
      PhoneBinding:"The bound mobile phone number cannot be empty",
      EmailBinding:"The bound email cannot be empty",
      Phone:"please enter a valid phone number",
      Email:"please enter your vaild email",
      VerificationTime:"The verification code can only be obtained every 60s",
      Account:"Please enter account Username",
      AccountEmpty:"Account Username cannot be empty",
      PasswordEmpty:"password can not be empty",
      PassengersNumbers:"The number of passengers has reached its limit, please contact customer service",
      ManyPeople:"If there are too many passengers, please contact customer service for group purchase",
      ChangeReason:"Change reason cannot be empty",
      SeatNumbers:"The number of passengers exceeds the number of seats selected",
      SelectSeat:"Please select a seat for the selected passenger",
    },
    succ: {
      SaveSucc:"Save successfully!",
      CancelSucc:"Cancel successfully",
      ApprovalRefused:"Approval rejected!",
      ApproveSucc:"Approved!",
      RefundSucc:"The refund application is submitted successfully",
      ChangeSucc:"The change application is submitted successfully!",
      RegisteredSucc:"registration success!",
      LoginSucc:"sign in successfully!",
      ChangePasswordSucc:"Password reset successfully!",
      VerificationSucc:"Verification code sent successfully",
      AddSucc:"Added successfully",
      ModifySucc:"modified Successfully ",
      DeleteSucc:"deleted successfully ",
      WeChat:"WeChat unbind successfully",
    },
    confirm: {
      YesOrNoDelect:"Confirm delete",
      CreateOrder:"The order is created successfully, you are welcome to follow the order progress in the order details at any time",
      ThankRemarks:"Thank you for your long-term support and trust in Licheng Business Trip. For improving the user experience, Licheng Business Trip 2.0 system officially launched at 9:00 am on 30th of oct in 2018. Users can update automatically through AppStore. For Android system  please contact our customer service. Emergency contact number:15901610043. Thank you."
    },
    loading: {
      load:"Processing",
      creatOrder:"Order is being created",
      PriceCalculation:"Price calculating",
    },
  },
  Categorys: {
    Young:"adult",
    Enfant:"child",
    Infant:"infant",
    economyClass:"economy class",
    buissenesClass:"business class",
    firstClass:"first class",
    OnBusiness:"For business",
    OnPersonal:"for personal",
    FlightService:"Air tickets",
    HotelService:"Hotel",
    TourService:"tourism",
    TrainService:"train",
    SingleVoyage:"One Way",
    RoundVoyage:"round way",
    WaitBooking:"To be booked",
    WaitConfirm:"to be confirmed",
    WaitPayment:"To be paid",
    WaitDispose:"to be processed",
    Finished:"completed",
    Canceled:"Cancelled",
    Rejected:"Returned",
    Cannot:"invalid",
    WaitApprove:"awaiting approval",
    Discrete:"Split",
    WaitSubmit:"awaiting submit",
    WaitRefund:"awaiting refund",
    Male:"male",
    Female:"Female",
    IDCard:"ID ",
    PassportCard:"passport",
    StudentCard:"Student card",
    OfficerCard:"Officer ID",
    HKMpermit:"Mainland Travel Permit for Hong Kong and Macau Residents",
    TaiWpermit:"Mainland Residents Traveling to Taiwan Permit",
    OtherCard:"other",
    Company:"the company",
    User:"user",
    HotelFare:"Room rate",
    TicketFare:"fare",
    MobileAuth:"phone account",
    EmailAuth:"email address",
    AccountAuth:"account password",
    WeixinAuth:"WeChat authorization",
    DynamicAuth:"dynamic password",
    MessageNotify:"SMS notification",
    MailNotify:"E-mail notification",
    WechatNotify:"WeChat notification",
    AppNotify:"App notification",
    Normal:"common",
    OverseasStudent:"student",
    Worker:"workers",
    Immigrant:"new immigrants",
    '1138Categorys':"ID ",
    '1139Categorys':"passport",
    '1140Categorys':"Student card",
    '1141Categorys':"Officer ID",
    '1298Categorys':"Mainland Travel Permit for Hong Kong and Macau Residents",
    '1299Categorys':"Mainland Residents Traveling to Taiwan Permit",
    '1142Categorys':"other",

    AmendingFlight:"Partial refunding",
    ChangeingFlight:"Partial changing",
    AmendingTrain:"Partial refunding",
    ChangeingTrain:"Partial changing",
    AmendingHotel:"Partial refunding",
    ChangeingHotel:"Partial changing",
    AmendingTour:"Partial withdrawal",
    ChangeingTour:"Partial changing",
    AmendedFlight:"Partial refund",
    ChangeedFlight:"Partial change",
    AmendedTrain:"Partial refund",
    ChangeedTrain:"Partial change",
    AmendedHotel:"Partial refund",
    ChangeedHotel:"Partial change",
    AmendedTour:"Partial withdrawal",
    ChangeedTour:"Partial change",
    AllAmendingFlight:"Refunding",
    AllChangeingFlight:"changing",
    AllBookingFlight:"booking",
    AllAmendingTrain:"Refunding",
    AllChangeingTrain:"changing",
    AllBookingTrain:"booking",
    AllAmendingHotel:"Refunding",
    AllChangeingHotel:"changing",
    AllBookingHotel:"Booking",
    AllAmendingTour:"Withdraw from the group",
    AllChangeingTour:"changing",
    AllBookingTour:"Booking",
    AllAmendedFlight:"refund successfully",
    AllChangeedFlight:"Change successfully",
    AllBookedFlight:"purchase successfully",
    AllAmendedTrain:"refund successfully",
    AllChangeedTrain:"Change successfully",
    AllBookedTrain:"purchase successfully",
    AllAmendedHotel:"refund successfully",
    AllChangeedHotel:"Change successfully",
    AllBookedHotel:"purchase successfully",
    AllAmendedTour:"Successful withdrawal",
    AllChangeedTour:"Change successfully",
    AllBookedTour:"purchase successfully",


  },
  RegExp: {
    AccountReg: {
      isEmpty:"Account name cannot be empty",
      isFormat:"Incorrect account format",
    },
    PwdReg: {
      isEmpty:"Password cannot be empty",
      isFormat:"Incorrect password format",
    },
    ConfigPwd: {
      isEmpty:"Password cannot be empty",
      isFormat:"Passwords does not match!",
    },
    VerificationCodeReg: {
      isEmpty: 'Verification code cannot be empty',
    },
    DynamicCodeReg: {
      isEmpty: 'Dynamic code cannot be empty',
    },
    ProtocolReg: {
      isFlag: 'Must comply with the agreement'
    }
  }
}
